import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { FounderProvider, useFounder } from './founder/FounderContext';
import { FounderLayout } from './founder/FounderLayout';
import {
  FounderLanding,
  FounderOnboarding,
  FounderDashboard,
  FounderRoadmap,
  FounderJournal,
  FounderLearning,
  FounderOpportunities,
  FounderSettings,
  FounderRecovery,
} from './founder/FounderScreens';

function FounderArea({ children }) {
  const { project, storageBlocked } = useFounder();
  if (storageBlocked) return <Navigate to="/recover" replace />;
  if (!project) return <Navigate to="/onboarding" replace />;
  return <FounderLayout>{children}</FounderLayout>;
}

export default function App() {
  return (
    <FounderProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FounderLanding />} />
          <Route path="/onboarding" element={<FounderOnboarding />} />
          <Route path="/recover" element={<FounderRecovery />} />
          <Route path="/app/dashboard" element={<FounderArea><FounderDashboard /></FounderArea>} />
          <Route path="/app/roadmap" element={<FounderArea><FounderRoadmap /></FounderArea>} />
          <Route path="/app/journal" element={<FounderArea><FounderJournal /></FounderArea>} />
          <Route path="/app/learn" element={<FounderArea><FounderLearning /></FounderArea>} />
          <Route path="/app/opportunities" element={<FounderArea><FounderOpportunities /></FounderArea>} />
          <Route path="/app/profile" element={<FounderArea><FounderSettings /></FounderArea>} />
          <Route path="/app/*" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </FounderProvider>
  );
}
